<template>
  <div>
    <div v-if="!modoBuscaDefinido" class="carregando-modo-busca">
      <b-spinner variant="secondary" label="Carregando produtos..."></b-spinner>
    </div>

    <lista-produtos-legada
      v-else-if="!servicoBuscaAtivo"
      :id="id"
      :results-per-page="resultsPerPage"
      :cliente_codigo="cliente_codigo"
      :cd_filial="cd_filial"
      @onAddMga="adicionarMga"
      @onAddItj="adicionarItj"
      @onAdd="adicionar"
    >
      <template v-slot:segundaColuna>
        <slot name="segundaColuna"></slot>
      </template>
      <template v-slot:terceiraColuna>
        <slot name="terceiraColuna"></slot>
      </template>
      <template v-slot:addButton="propriedadesSlot">
        <slot name="addButton" :data="propriedadesSlot.data"></slot>
      </template>
    </lista-produtos-legada>

    <template v-else>
      <barra-busca-produtos
        ref="barraBusca"
        :mostrar-segunda-coluna="temSegundaColuna"
        :mostrar-terceira-coluna="temTerceiraColuna"
        :somente-favoritos="somenteFavoritos"
        :termo-busca="termoBusca"
        :carregando-sugestoes="carregandoSugestoes"
        :mostrar-sugestoes="mostrarSugestoes"
        :sugestoes="sugestoes"
        @alterarFavoritos="alterarFavoritos"
        @alterarTermo="termoBusca = $event"
        @teclaBusca="carregarSugestoes"
        @limparBusca="limparBusca"
        @usarSugestao="usarSugestao"
        @fecharSugestoes="fecharSugestoes"
      >
        <template v-slot:segundaColuna>
          <slot name="segundaColuna"></slot>
        </template>
        <template v-slot:terceiraColuna>
          <slot name="terceiraColuna"></slot>
        </template>
      </barra-busca-produtos>

      <b-row class="mb-3">
        <b-col class="coluna-filtros-servico">
          <filtros-servico-busca
            :tem-filtros-ativos="temFiltrosAtivos"
            :filtros="filtrosServicoBusca"
            :selecionados="filtrosServicoBuscaSelecionados"
            :carregando="carregandoFiltros"
            @alterar="alterarFiltroServicoBusca"
            @limpar="limparTodosFiltros"
          />
        </b-col>

        <b-col class="coluna-resultados-servico">
          <grade-resultados-produtos
            :tracking-ativo="servicoBuscaAtivo"
            :resultados="resultados"
            :carregando="carregandoProdutos"
            :cliente-codigo="cliente_codigo"
            :codigo-filial="cd_filial"
            :termo-busca="termoPesquisaAtual"
            @adicionarMga="adicionarMga"
            @adicionarItj="adicionarItj"
            @adicionar="adicionar"
            @ocultarProduto="ocultarProduto"
            @favoritar="atualizarFavorito"
          >
            <template v-slot:addButton="propriedadesSlot">
              <slot name="addButton" :data="propriedadesSlot.data"></slot>
            </template>
          </grade-resultados-produtos>

          <sentinela-rolagem-infinita
            :ativo="podeCarregarMais"
            :carregando="carregandoProdutos"
            @visivel="carregarProdutos"
          />
        </b-col>
      </b-row>

      <go-to-top></go-to-top>
    </template>
  </div>
</template>

<script>
import GoToTop from "@/components/ui/GoToTop.vue";
import Analytics from "@/services/analytics";
import Produto from "@/services/produto";
import ServicoBuscaTracking from "@/services/servicoBuscaTracking";
import barraBuscaProdutos from "./componentes/barraBuscaProdutos";
import filtrosServicoBusca from "./componentes/filtrosServicoBusca";
import gradeResultadosProdutos from "./componentes/gradeResultadosProdutos";
import listaProdutosLegada from "./componentes/listaProdutosLegada";
import sentinelaRolagemInfinita from "./componentes/sentinelaRolagemInfinita";

export default {
  name: "ProductList",
  components: {
    GoToTop,
    barraBuscaProdutos,
    filtrosServicoBusca,
    gradeResultadosProdutos,
    listaProdutosLegada,
    sentinelaRolagemInfinita,
  },
  props: {
    id: {
      type: String,
      default: "ProductList",
    },
    resultsPerPage: {
      type: Number,
      default: 10,
    },
    cliente_codigo: {
      type: Number,
      default: 0,
    },
    cd_filial: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      temporizadorSugestoes: null,
      versaoSugestoes: 0,
      sugestoes: [],
      carregandoProdutos: false,
      carregandoFiltros: true,
      carregandoSugestoes: false,
      buscaProdutosPendente: false,
      mostrarSugestoes: false,
      termoBusca: "",
      termoPesquisaAtual: "",
      somenteFavoritos: false,
      dadosBusca: {
        params: {
          search: {},
          page: 1,
          resultsPerPage: this.resultsPerPage,
          sortColumn: null,
          sortDirection: null,
          cd_filial: this.cd_filial,
          cliente_codigo: this.cliente_codigo,
        },
      },
      resultadoBusca: {},
      resultados: [],
      modoBusca: "carregando",
      filtrosServicoBusca: [],
      filtrosServicoBuscaSelecionados: {},
    };
  },
  computed: {
    temSegundaColuna() {
      return !!(this.$scopedSlots.segundaColuna || this.$slots.segundaColuna);
    },
    temTerceiraColuna() {
      return !!(this.$scopedSlots.terceiraColuna || this.$slots.terceiraColuna);
    },
    servicoBuscaAtivo() {
      return this.modoBusca === "servicoBusca";
    },
    modoBuscaDefinido() {
      return this.modoBusca !== "carregando";
    },
    temTermoBusca() {
      return this.normalizarTexto(this.termoBusca) !== "";
    },
    temFiltrosServicoBusca() {
      return Object.keys(this.filtrosServicoBuscaSelecionados).some((campo) => {
        return (this.filtrosServicoBuscaSelecionados[campo] || []).length > 0;
      });
    },
    temFiltrosAtivos() {
      return (
        this.temTermoBusca ||
        this.somenteFavoritos === true ||
        this.temFiltrosServicoBusca
      );
    },
    podeCarregarMais() {
      const totalPaginas = Number(this.resultadoBusca.totalPages || 0);
      const proximaPagina = Number(this.dadosBusca.params.page || 1);

      return totalPaginas > 0 && proximaPagina <= totalPaginas;
    },
  },
  created() {
    this.carregarProdutos();
  },
  beforeDestroy() {
    clearTimeout(this.temporizadorSugestoes);
    this.versaoSugestoes += 1;
  },
  methods: {
    normalizarTexto(valor) {
      return String(valor == null ? "" : valor).trim();
    },
    carregarProdutos(dados = null, forcarPesquisa = false) {
      const dadosRequisicao = dados || this.dadosBusca;

      if (
        this.carregandoProdutos ||
        (!forcarPesquisa && !this.podeCarregarMais && this.modoBuscaDefinido)
      ) {
        return;
      }

      const paginaSolicitada = Number(dadosRequisicao.params.page) || 1;
      if (paginaSolicitada === 1) {
        const parametrosPesquisa = dadosRequisicao.params.search || {};
        this.termoPesquisaAtual =
          parametrosPesquisa.content || this.termoBusca || "";
      }

      this.carregandoProdutos = true;
      if (Number(dadosRequisicao.params.page) === 1) {
        this.resultadoBusca.totalResults = -1;
      }

      dadosRequisicao.params.cliente_codigo = this.obterCodigoCliente();
      dadosRequisicao.params.produtos_favoritos = this.somenteFavoritos;
      let carregarProximaPagina = false;

      Produto.getListaProdutos(dadosRequisicao)
        .then((response) => {
          if (this.buscaProdutosPendente) {
            return;
          }

          const resultado = response.data.data || {};
          const produtosPagina = Object.keys(resultado.results || {}).map(
            (chave) => resultado.results[chave]
          );

          this.resultadoBusca = resultado;
          this.aplicarModoBusca(resultado);
          if (this.servicoBuscaAtivo) {
            this.registrarPaginaPesquisa(paginaSolicitada);
          }
          this.carregandoFiltros = false;
          this.adicionarResultados(produtosPagina);
          this.mostrarAvisoSemResultados(paginaSolicitada, produtosPagina);

          if (this.servicoBuscaAtivo) {
            Analytics.trackViewItemList(produtosPagina, this.$store);
          }

          const paginaAtual = Number(resultado.page || dadosRequisicao.params.page);
          const totalPaginas = Number(resultado.totalPages || 0);
          this.dadosBusca.params.page = paginaAtual + 1;

          carregarProximaPagina =
            this.servicoBuscaAtivo &&
            produtosPagina.length === 0 &&
            paginaAtual < totalPaginas;
        })
        .catch((erro) => {
          if (this.buscaProdutosPendente) {
            return;
          }

          this.carregandoFiltros = false;
          this.tratarErroBusca(erro);
        })
        .finally(() => {
          this.carregandoProdutos = false;

          if (this.buscaProdutosPendente) {
            this.buscaProdutosPendente = false;
            this.carregarProdutos(this.dadosBusca, true);
            return;
          }

          if (carregarProximaPagina) {
            this.carregarProdutos();
          }
        });
    },
    obterCodigoCliente() {
      if (this.cliente_codigo && this.cliente_codigo !== 0) {
        return this.cliente_codigo;
      }

      return this.$store.state.carrinhoitj.cliente_codigo == null
        ? this.$store.state.carrinho.cliente_codigo
        : this.$store.state.carrinhoitj.cliente_codigo;
    },
    adicionarResultados(produtos) {
      const codigosExistentes = this.resultados.reduce((codigos, produto) => {
        codigos[String(produto.codigo)] = true;
        return codigos;
      }, {});

      produtos.forEach((produto) => {
        const codigo = String(produto.codigo);
        if (!codigosExistentes[codigo]) {
          this.resultados.push(produto);
          codigosExistentes[codigo] = true;
        }
      });
    },
    mostrarAvisoSemResultados(paginaSolicitada, produtos) {
      if (
        paginaSolicitada === 1 &&
        this.normalizarTexto(this.termoPesquisaAtual) !== "" &&
        produtos.length === 0 &&
        this.resultados.length === 0
      ) {
        this.$helper.showMsg("Nenhum produto encontrado.", "warning");
      }
    },
    tratarErroBusca(erro) {
      if (this.somenteFavoritos) {
        this.$helper.showMsg(
          "Nao foram encontrados produtos favoritos. Para exibir todos produtos, desmarque o filtro 'Produtos Favoritos'",
          "warning"
        );
      } else {
        this.$helper.showErrorResponse(erro);
      }

      if (erro.response && erro.response.status === 404 && erro.response.data) {
        this.resultados = [];
        this.limparBusca();
      }
    },
    aplicarModoBusca(resultado) {
      if (resultado.servicoBuscaAtivo) {
        this.modoBusca = "servicoBusca";
        this.$emit("alterarModoBusca", true);
        this.filtrosServicoBusca = Array.isArray(resultado.filtrosServicoBusca)
          ? resultado.filtrosServicoBusca
          : [];
        return;
      }
      this.modoBusca = "legado";
      this.$emit("alterarModoBusca", false);
      this.filtrosServicoBusca = [];
      this.filtrosServicoBuscaSelecionados = {};
    },
    alterarFavoritos(valor) {
      this.somenteFavoritos = valor === true || valor === "true";
      this.reiniciarBusca();
    },
    carregarSugestoes(evento) {
      clearTimeout(this.temporizadorSugestoes);
      this.temporizadorSugestoes = null;
      this.versaoSugestoes += 1;
      const versaoSugestoes = this.versaoSugestoes;

      this.sugestoes = [];
      this.mostrarSugestoes = false;
      this.carregandoSugestoes = false;

      if (evento.key === "Enter") {
        this.buscarTexto();
        return;
      }

      if (!this.temTermoBusca) {
        return;
      }

      const termoBusca = this.normalizarTexto(this.termoBusca);
      this.temporizadorSugestoes = setTimeout(() => {
        this.carregandoSugestoes = true;
        Produto.getSearchSuggestions(termoBusca)
          .then((response) => {
            if (versaoSugestoes !== this.versaoSugestoes) {
              return;
            }

            this.sugestoes = response.data.data || [];
            this.mostrarSugestoes = true;
          })
          .catch((erro) => {
            if (versaoSugestoes === this.versaoSugestoes) {
              console.log(erro);
            }
          })
          .finally(() => {
            if (versaoSugestoes !== this.versaoSugestoes) {
              return;
            }

            this.carregandoSugestoes = false;
          });
      }, 500);
    },
    fecharSugestoes(perderFoco = false) {
      clearTimeout(this.temporizadorSugestoes);
      this.temporizadorSugestoes = null;
      this.versaoSugestoes += 1;
      this.sugestoes = [];
      this.mostrarSugestoes = false;
      this.carregandoSugestoes = false;

      if (perderFoco) {
        this.$nextTick(() => {
          if (this.$refs.barraBusca) {
            this.$refs.barraBusca.desfocarBusca();
          }
        });
      }
    },
    criarParametrosBusca() {
      const parametros = {};

      Object.keys(this.filtrosServicoBuscaSelecionados).forEach((campo) => {
        const valores = this.filtrosServicoBuscaSelecionados[campo] || [];
        if (valores.length > 0) {
          parametros[campo] = valores.join(",");
        }
      });

      if (this.temTermoBusca) {
        parametros.content = this.termoBusca;
      }

      return parametros;
    },
    buscarTexto() {
      if (this.temTermoBusca) {
        Analytics.trackSearch(this.normalizarTexto(this.termoBusca), this.$store);
      }

      this.rolarParaTopoProdutos();
      this.fecharSugestoes(true);
      this.reiniciarBusca();
    },
    reiniciarBusca() {
      this.carregandoFiltros = true;
      this.resultados = [];
      this.dadosBusca.params.search = this.criarParametrosBusca();
      this.dadosBusca.params.page = 1;
      this.dadosBusca.params.sortColumn = "";
      this.dadosBusca.params.sortDirection = "asc";
      this.dadosBusca.params.resultsPerPage = this.resultsPerPage;

      if (this.carregandoProdutos) {
        this.buscaProdutosPendente = true;
        return;
      }

      this.carregarProdutos(this.dadosBusca, true);
    },
    limparBusca() {
      this.termoBusca = "";
      this.somenteFavoritos = false;
      this.fecharSugestoes();
      this.reiniciarBusca();
    },
    limparTodosFiltros() {
      if (this.carregandoFiltros) {
        return;
      }

      this.filtrosServicoBuscaSelecionados = {};
      this.termoBusca = "";
      this.somenteFavoritos = false;
      this.fecharSugestoes();
      this.reiniciarBusca();
    },
    alterarFiltroServicoBusca(item, selecionado) {
      if (this.carregandoFiltros) {
        return;
      }

      const campo = item.id;
      const valor = this.normalizarTexto(item.valor);

      if (!campo || !valor) {
        return;
      }

      const filtros = Object.assign({}, this.filtrosServicoBuscaSelecionados);
      let valores = filtros[campo] ? filtros[campo].slice() : [];
      const indice = valores.indexOf(valor);

      if (this.normalizarTexto(campo).toLowerCase() === "linha" && selecionado) {
        valores = [valor];
      } else if (selecionado && indice === -1) {
        valores.push(valor);
      } else if (!selecionado && indice > -1) {
        valores.splice(indice, 1);
      }

      if (valores.length > 0) {
        filtros[campo] = valores;
      } else {
        delete filtros[campo];
      }

      this.filtrosServicoBuscaSelecionados = filtros;
      this.reiniciarBusca();
    },
    obterCodigoSugestao(sugestao) {
      const codigo = String(sugestao == null ? "" : sugestao).match(
        /^\s*(\d+)(?:\s*[-_]|\s*$)/
      );
      return codigo ? codigo[1] : "";
    },
    registrarPaginaPesquisa(paginaSolicitada) {
      ServicoBuscaTracking.enviarPagina({
        tipoPagina:
          paginaSolicitada === 1 && Number(this.resultadoBusca.totalResults) === 0
            ? "notfound"
            : "search",
        precoProduto: 0,
      });
    },
    usarSugestao(sugestao, indice) {
      const termoPesquisado = this.termoBusca || "";
      const codigoProduto = this.obterCodigoSugestao(sugestao);

      if (codigoProduto) {
        ServicoBuscaTracking.enviarClick({
          evento: Analytics.buildClickEvent({
            codigoProduto,
            preco: 1,
            termo: termoPesquisado,
          }),
          urlProduto: "",
          tipoPagina: "search",
          feature: "search",
          posicaoProduto: indice + 1,
        });
      }

      this.termoBusca = codigoProduto || sugestao;
      this.buscarTexto();
    },
    rolarParaTopoProdutos() {
      const topo = document.getElementById("topo-lista-produtos");
      if (topo && topo.scrollIntoView) {
        topo.scrollIntoView({ block: "start" });
      }
    },
    adicionarMga(dados) {
      this.$emit("onAddMga", dados);
    },
    adicionarItj(dados) {
      this.$emit("onAddItj", dados);
    },
    adicionar() {
      this.$emit("onAdd", false);
    },
    ocultarProduto(codigoProduto) {
      const indice = this.resultados.findIndex(
        (produto) => produto.codigo == codigoProduto
      );
      if (indice > -1) {
        this.resultados.splice(indice, 1);
      }
    },
    atualizarFavorito(codigoProduto, favorito) {
      const produto = this.resultados.find(
        (item) => item.codigo == codigoProduto
      );
      if (produto) {
        produto.favorito = favorito;
      }
    },
  },
};
</script>

<style scoped>
.carregando-modo-busca {
  min-height: 10rem;
  padding: 4rem 0;
  text-align: center;
}

.coluna-filtros-servico,
.coluna-resultados-servico {
  flex: 0 0 100%;
  max-width: 100%;
}

@media (min-width: 1024px) {
  .coluna-filtros-servico {
    flex: 0 0 16.6666667%;
    max-width: 16.6666667%;
  }

  .coluna-resultados-servico {
    flex: 0 0 83.3333333%;
    max-width: 83.3333333%;
  }
}
</style>
